import { Switch } from '@headlessui/react'
import { Fragment, useState, type ChangeEvent } from 'react'

export interface FormCheckbox {
  className?: string
  inputClassName?: string
  name?: string
  id?: string
  ariaDescribedby?: string
  children?: JSX.Element
  checked?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const FormCheckbox = ({
  className = '',
  onChange = () => true,
  checked = false,
  name,
  children,
}: FormCheckbox) => {
  const [enabled, setEnabled] = useState(checked)
  const onListBoxChange = (checkboxValue: unknown) => {
    onChange({
      target: { value: checkboxValue, name },
    } as ChangeEvent<HTMLInputElement>)
    setEnabled(!checked)
  }
  return (
    <Switch
      checked={enabled}
      onChange={setEnabled => {
        onListBoxChange(setEnabled)
      }}
      as={Fragment}
    >
      {({ checked }) => (
        <div className='flex flex-wrap justify-start'>
          <div
            className={`${className} relative box-border h-[18px] w-[18px] max-w-[18px] flex-[18px] appearance-none rounded-[5px] border text-mainBody border-dark-700 mt-[1px] ${
              checked
                ? 'bg-border-primary before:absolute before:left-[4px] before:top-[-3px] before:content-[url("/check.svg")]  relative box-border h-[18px] w-[18px] appearance-none rounded-[5px] border text-mainBody border-orange'
                : 'bg-white'
            } 
         `}
          ></div>
          {children}
        </div>
      )}
    </Switch>
  )
}
